import Layout from '@/layout'
import ParentView from '@/components/ParentView'
const itemCategoryRoutes =
{
  path: '/oa/medium',
  component: Layout,
  redirect: 'noredirect',
  name: '培养基管理',
  funcPerms: 'oa:culmed',
  meta: {
    title: '培养基管理',
    icon: 'medium',
    affix: false,
    noCache: true
  },
  children: [
    // {
    //   path: '/Inven',
    //   component: () => import('@/views/oa/inventory/Inven/index.vue'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'Inven',
    //   meta: {
    //     title: '库存查询',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/subsidiary',
    //   component: () => import('@/views/oa/inventory/subsidiary/index.vue'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'subsidiary',
    //   meta: {
    //     title: '入库明细',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/Outbound',
    //   component: () => import('@/views/oa/inventory/Outbound/index.vue'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'Outbound',
    //   meta: {
    //     title: '出库明细',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/statistics',
    //   component: () => import('@/views/oa/inventory/statistics/index.vue'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'statistics',
    //   hidden: true,
    //   meta: {
    //     title: '出入库统计',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/Application',
    //   component: () => import('@/views/oa/inventory/Application/index.vue'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'Application',
    //   meta: {
    //     title: '使用申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/Application/query',
    //   component: () => import('@/views/oa/inventory/Application/query.vue'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'Application/query',
    //   hidden: true,
    //   meta: {
    //     title: '查询库存',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/AuditOutbound',
    //   component: () => import('@/views/oa/inventory/AuditOutbound/index.vue'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'AuditOutbound',
    //   meta: {
    //     title: '库管审核出库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/InventoryImport',
    //   component: () => import('@/views/oa/inventory/InventoryImport/index.vue'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'InventoryImport',
    //   meta: {
    //     title: '库存导入',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'medium/list',
      component: () => import('@/views/oa/inventory/medium/index.vue'),
      funcPerms: 'oa:culmed:mgr',
      name: 'medium',
      meta: {
        title: '培养基管理',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'medium/add',
      component: () => import('@/views/oa/inventory/medium/addoredit.vue'),
      funcPerms: 'oa:hr:manager',
      name: 'MediumAdd',
      hidden: true,
      meta: {
        title: '培养基新增',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'medium/view',
      component: () => import('@/views/oa/inventory/medium/view.vue'),
      funcPerms: 'oa:hr:manager',
      name: 'medium/view',
      hidden: true,
      meta: {
        title: '培养基查看',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'medium/edit',
      component: () => import('@/views/oa/inventory/medium/addoredit.vue'),
      funcPerms: 'oa:hr:manager',
      name: 'medium/edit',
      hidden: true,
      meta: {
        title: '培养基编辑',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'CultureMedium',
      component: () => import('@/views/oa/inventory/CultureMedium/index.vue'),
      funcPerms: 'oa:culmed:apply',
      name: 'CultureMedium',
      meta: {
        title: '培养基申请',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
  ]
}

export default itemCategoryRoutes
